/* global window */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import R from 'ramda';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {
  init,
} from './__storeFiles__/actions';

import muiTheme from '../../utils/muiTheme';
import HelpWidget from '../tc-ui/help-widget';
import { CircularProgress } from 'material-ui';
import Dialog from './dialog/dialog';
import ContractDocDownloadPopover from '../containers/downloadPopover';

const propTypes = {
  state: PropTypes.object,
  init: PropTypes.func,
  children: PropTypes.any,
};

class AssetsLandingRouter extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // link in the email were wrapped in double paren, handlebar was converting url unnecessarily
    // this is to handle the emails that already sent out.
    if (window.location.href.indexOf('&#x3D;') > -1) {
      window.location = R.clone(window.location.href).replace('&#x3D;', '=');
    }
    const hashToken =
      R.path(['location', 'query', 'hashToken'], this.props) ||
      R.path(['location', 'query', 'amp;hashToken'], this.props) ||
      '';
    const contractId =
      R.path(['location', 'query', 'contractId'], this.props) ||
      R.path(['location', 'query', 'amp;contractId'], this.props) ||
      '';
    const DL =
      R.path(['location', 'query', 'DL'], this.props) ||
      R.path(['location', 'query', 'amp;DL'], this.props) ||
      '';
    const jumpBackTo =
      R.path(['location', 'query', 'jumpBackTo'], this.props) ||
      R.path(['location', 'query', 'amp;jumpBackTo'], this.props) ||
      '';

    if (hashToken) {
      this.props.init({
        hashToken: hashToken.trim(),
        shortid: hashToken.trim(),
        contractId,
        DL: Boolean(DL),
        jumpBackTo,
      });
    }
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={{ height: '100%' }}>
          {
            this.props.state.initialLoading
              ? (
                <div style={{ padding: '150px 20%', textAlign: 'center' }}>
                  <CircularProgress size={100} thickness={7} />
                  <div
                    style={{
                      fontSize: '20px',
                      color: 'rgba(0, 0, 0, 0.54)',
                      whiteSpace: 'pre-wrap',
                      width: '50%',
                      margin: '28px auto',
                      lineHeight: '28px',
                    }}
                  >
                    Just a few moments, we are retrieving information for you.
                  </div>
                </div>
              ) : this.props.children
          }
          <HelpWidget companyType={this.props.state.viewAs} acctCreationReason={''} />
          <Dialog
            {...this.props.state.dialog}
            loggedInSession={this.props.state.loggedInSession}
            assetOwnerEmail={this.props.state.email}
            hashToken={this.props.state.hashToken}
            userId={this.props.state.userId}
            ratesOrRequests={this.props.state.ratesOrRequests}
            ratesOrRequestsLabel={this.props.state.ratesOrRequestsLabel}
            wrongAccountWarningText={this.props.state.wrongAccountWarningText}
            country={this.props.state.country}
          />
          <ContractDocDownloadPopover alContractIds={this.props.state.contractIds}/>
        </div>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = state => ({ state: state.assetsLandingReducer });

const mapDispatchToProps = {
  init,
};
AssetsLandingRouter.propTypes = propTypes;
AssetsLandingRouter.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetsLandingRouter);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/router.jsx